"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDevelopmentAddress = isDevelopmentAddress;
function isDevelopmentAddress(url) {
    var developmentAddresses = ['0.0.0.0', '127.0.0.1', 'localhost'];
    return developmentAddresses.indexOf(url) >= 0;
}
